<template>
  <!--  首页-->
  <el-tabs class="common-tabs" v-model="activeName" @tab-click="handleTabClick">
    <el-tab-pane label="数据上传" name="tabUpload" v-if="userMenu.indexOf('数据上传') >= 0">
      <myDnUpload></myDnUpload>
    </el-tab-pane>
    <el-tab-pane label="数据下载" name="tabDown" v-if="userMenu.indexOf('数据下载') >= 0"></el-tab-pane>
    <el-tab-pane label="系统管理" name="tabSystem" v-if="userMenu.indexOf('系统管理') >= 0"></el-tab-pane>
  </el-tabs>
</template>

<script>
import myDnUpload from '@/components/pages/myDnUpload/index'
export default {
  name: 'myHome',
  data () {
    return {
      activeName: 'tabUpload',
      userMenu: this.$userMenu
    }
  },
  components: {
    myDnUpload
  },
  // created () {
  //   this.activeName = 'tabUpload'
  // },
  methods: {
    handleTabClick () {
      if (this.activeName === 'tabDown') {
        this.$router.push({ name: 'myDnload' })
      } else if (this.activeName === 'tabSystem') {
        this.$router.push({ name: 'mySystemMessager' })
      }
    }
  }

}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/pages/myHome/myHome.vue